import { COLORS } from '@constants';
import { Row } from 'antd';
import styled from 'styled-components';

export const StyledStoreUrl = styled(Row)`
    margin-bottom: 24px;
    padding: 16px;
    border: 1px solid ${COLORS.$gray20Black};
    border-radius: 8px;
`;

export const StyledAlert = styled.div`
    padding: 23px 24px;
    border: 1px solid ${({ $isValid }) => ($isValid ? COLORS.$robinBlue : COLORS.$tartRed)};
    border-radius: 8px;
    background: ${({ $isValid }) => ($isValid ? COLORS.$robinTintsBlue : COLORS.$tartRedLite)};
`;
